<!-- 流程图查看 -->
<template>
  <el-dialog :visible.sync="visible"
             :title="$t('activiti.flowChart')"
             :close-on-click-modal="false"
             :close-on-press-escape="false"
             width="1000px">
    <div class="centerDiv">
      <img alt="" :src='this.picUrl' />
    </div>
    <template slot="footer"></template>
  </el-dialog>
</template>

<script>
export default {
  data () {
    return {
      visible: false,
      picUrl: '',
      processId: ''
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        if (this.processId && this.processId !== '') {
          this.picUrl = ''
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$request.getAct('/act/operate/getShineProcImage', {
        processId: this.processId
      }).then((res) => {
        // TOOD 将base64放到src中
        this.picUrl = 'data:image/png;base64,' + res
      }).catch((err) => {
        console.log(err)
      })
    }
  }
}
</script>
<style lang="scss" scope>
.centerDiv {
  text-align: center
}
</style>
